export { default as TextClamp } from './text-clamp'
